import { useAuth } from '../useAuth/useAuth'

import { getPartnerFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'
import { VolunteeringAllowancePeriodicity } from '@percent/workplace-giving/api/auth/getPartnerVolunteeringConfig/getPartnerVolunteeringConfig.types'

export function useVolunteeringAllowancePeriod() {
  const { state } = useAuth()
  const period = getPartnerFromAuthState(state)?.volunteeringAllowancePeriodicity ?? null

  return {
    period,
    translationKey:
      period === VolunteeringAllowancePeriodicity.Quarterly
        ? 'workplace_giving.common.thisQuarter'
        : 'workplace_giving.common.thisFiscalYear'
  } as const
}
